import { validationOptions } from '../../../types/interface';

export const ValidationEnum: validationOptions = {
  REQUIRED: 'Required',
  MAXLENGTH: 'MaxLength',
  MINLENGTH: 'MinLength',
  LENGTH: 'Length',
  PATTERN: 'Pattern',
  COMPAREVALUE: 'CompareValue',
  MIN: 'Min',
  MAX: 'Max',
  STRINGVALIDATE: 'StringValidate',
  INTEGERVALIDATE: 'IntegerValidate',
  WORDLIMITVALIDATE: 'WordLimitValidate'
};
